module.exports = __webpack_public_path__ + "media/images/gifts/music/sug_musica_8-1f65ea505871683b15b3668bf3b951c9.jpg";